// extracted by mini-css-extract-plugin
export default {"wrap":"CH-z","fullWidth":"DH-z","hideOnDesktop":"EH-z","content":"FH-z","hasOpenedNav":"GH-z","crumbsList":"HH-z","dropdownsWrap":"IH-z"};